import { render, staticRenderFns } from "./sw.vue?vue&type=template&id=9e559572&scoped=true"
import script from "./sw.vue?vue&type=script&lang=js"
export * from "./sw.vue?vue&type=script&lang=js"
import style0 from "./sw.vue?vue&type=style&index=0&id=9e559572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e559572",
  null
  
)

export default component.exports